export {
  filterCategoriesForPos as filterCategoriesForBooking,
  resolveServicePrice as resolveBookServicePrice,
  toPosAmount,
} from '@/components/pos/posCatalog'

/** @typedef {'ladies' | 'gents'} BookPricingGender */

export const BOOK_GENDER_TOGGLE_OPTIONS = [
  { value: 'ladies', label: 'L', titleKey: 'pos.ladies' },
  { value: 'gents', label: 'G', titleKey: 'pos.gents' },
]

/**
 * @param {{ price_ladies?: number | string, price_gents?: number | string }} service
 * @param {BookPricingGender} gender
 */
export function serviceBookableForGender(service, gender) {
  const amount = gender === 'gents'
    ? Number(service.price_gents ?? 0)
    : Number(service.price_ladies ?? service.price ?? 0)

  return Number.isFinite(amount) && amount > 0
}

/**
 * @param {import('@/components/pos/posCatalog').PosGender} gender
 * @param {string | null | undefined} slug
 */
export function readStoredBookPricingGender(gender, slug) {
  if (gender === 'ladies' || gender === 'gents') {
    return gender
  }

  if (!slug || typeof window === 'undefined') {
    return 'ladies'
  }

  const stored = window.sessionStorage.getItem(`book:pricing-gender:${slug}`)
  return stored === 'gents' ? 'gents' : 'ladies'
}

/**
 * @param {string | null | undefined} slug
 * @param {BookPricingGender} gender
 */
export function storeBookPricingGender(slug, gender) {
  if (!slug || typeof window === 'undefined') {
    return
  }

  window.sessionStorage.setItem(`book:pricing-gender:${slug}`, gender)
}
